import { Pipe, PipeTransform } from '@angular/core';
import * as numbro from 'numbro/dist/numbro';
@Pipe({
  name: 'numbro'
})
export class NumbroPipe implements PipeTransform {

  transform(value: any, type: string, args: any[]): any {

    // type values can be - Number, Currency, Average, Bytes, Percentage,Time
    // Args sequence can be - mantissa (decimal digit),average(true or false),spaceSeparated (true or false)
    let numbroValue: any = 0;
    let decimalDigit: any = 0;
    if (value == null) {
      return value;
    } else {
      decimalDigit = args[0];
      if (type === 'number') {
        if (value < 1000000) {
          numbroValue = numbro(value).format({
            thousandSeparated: true
            //mantissa: +decimalDigit --To hide the decimal points in dashboard statistics
          });
        } else {

          numbroValue = numbro(value).format({
            thousandSeparated: true,
            average: true,
            mantissa: +decimalDigit
          });
        }
      } else if (type === 'bytes') {
        numbroValue = numbro(value).format({
          output: 'byte',
          base: 'binary',
          mantissa: +decimalDigit
        });
      }

      return numbroValue;
    }
  }
}
